import {
  clientAuthorizedDelete,
  clientAuthorizedGet,
  clientAuthorizedPost,
} from 'utils/fetchUtils';
import { API_ROUTES } from 'utils/constants';

export type CompanyInstalledAppsResponse = {
  installedAppIds: string[];
};

export async function fetchCompanyInstalledApps(
  companyId: string,
): Promise<CompanyInstalledAppsResponse> {
  return clientAuthorizedGet<CompanyInstalledAppsResponse>(
    API_ROUTES.COMPANY_APPS,
    undefined,
    companyId,
  );
}

export async function installCompanyApp(
  companyId: string,
  appId: string,
): Promise<CompanyInstalledAppsResponse> {
  return clientAuthorizedPost<CompanyInstalledAppsResponse>(
    API_ROUTES.COMPANY_APP_INSTALL(appId),
    {},
    companyId,
  );
}

export async function uninstallCompanyApp(
  companyId: string,
  appId: string,
): Promise<CompanyInstalledAppsResponse> {
  const response = await clientAuthorizedDelete<CompanyInstalledAppsResponse>(
    API_ROUTES.COMPANY_APP_UNINSTALL(appId),
    undefined,
    companyId,
  );
  if (response) {
    return response;
  }
  return fetchCompanyInstalledApps(companyId);
}
